/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { TransactionDetails } from './TransactionDetails';
const TransactionPendingParser = /* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('transaction-pending')],
    ['details', TransactionDetails],
]);
export class TransactionPending extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TransactionPendingParser.decode(input).map(res => new TransactionPending(res));
    }
    static unsafeDecode(input) {
        return TransactionPending.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TransactionPendingParser.encode(data);
    }
    static schema() {
        return TransactionPendingParser.schema();
    }
}
